const backdrop = [{ src: "/ledger.jpg", layer: "ground" }];

export default function Hero() {
  return (
    <section id="home" className="t-hero" aria-labelledby="hero-title">
      <div className="t-hero__bg" aria-hidden="true">
        {backdrop.map((item) => (
          <div key={item.src} className={`t-hero__layer t-hero__layer--${item.layer}`}>
            <img src={item.src} alt="" width={900} height={1118} decoding="async" fetchPriority="high" />
          </div>
        ))}
      </div>

      <div className="t-wrap">
        <div className="t-hero__copy">
          <h1 id="hero-title" className="t-h1 t-rise">
            Finance automation for accounting firms.
          </h1>
          <p className="t-lead t-hero__lead t-rise">
            I build the document chase, the close checklist, the reconciliation and the reporting
            pack that hold a close together. Seven years in accounting and finance, then five years
            writing the software that takes the manual work out of it.
          </p>
          <div className="t-hero__actions t-rise">
            <a className="t-btn" href="#contact">
              Start a project
            </a>
            <a className="t-btn t-btn--ghost" href="#services">
              See the work
            </a>
          </div>
          <p className="t-hero__meta t-rise">
            <span>Fixed scope, fixed price</span>
            <span>Built in your stack</span>
            <span>Reply within one business day</span>
          </p>
        </div>
      </div>
    </section>
  );
}
